/**
 * Timeline time formatting for the ticket Activity feed (§15.4).
 *
 * Field-service events (dispatch, field-engineer, visit) happen AT the
 * customer's site, so their timestamp matters in both the site's clock and the
 * viewer's — they render in dual format ("15 Jun 09:55 CEST · 13:25 IST").
 * Lifecycle events (status change, comment, assignment, …) are about the desk's
 * own workflow and stay viewer-only.
 *
 * Pure + viewer-zone-injected so it's unit-testable without a browser.
 */
import { formatDualZone, formatWithZone } from './timeDisplay';
/** Activity categories that occur at the on-site location → dual-format. */
export const FIELD_SERVICE_ACTIVITY_CATEGORIES = new Set(['dispatch', 'field_engineer', 'visit']);
/**
 * The timeline time string for one activity row.
 *  - Field-service event AND a known site zone that differs from the viewer's
 *    → dual "site · viewer".
 *  - Otherwise → viewer-only (lifecycle events, or site zone absent/equal).
 *
 * Guards on the RAW `site_timezone` so a genuinely absent zone stays viewer-
 * only (the backend ships "UTC" only when it actually resolved to UTC).
 */
export function activityTimeDisplay(item, viewerTz) {
    const siteTz = item.site_timezone?.trim();
    if (siteTz && siteTz !== viewerTz && FIELD_SERVICE_ACTIVITY_CATEGORIES.has(item.category)) {
        return formatDualZone(item.occurred_at, siteTz, viewerTz);
    }
    return formatWithZone(item.occurred_at, viewerTz);
}
